module.exports = __webpack_public_path__ + "img/质量管理检验.ea2a0235.svg";